"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRecognizerSubscription = void 0;
const react_1 = require("react");
const useRecognizerSubscription = (handler) => {
    (0, react_1.useEffect)(() => {
        document.addEventListener('recognizeWordEvent', handler);
        return () => {
            document.removeEventListener('recognizeWordEvent', handler);
        };
    }, [handler]);
};
exports.useRecognizerSubscription = useRecognizerSubscription;
